import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(
  ({ theme }) => ({
    margin: theme.spacing(32 , 0, 16, 0),
    [theme.breakpoints.down('lg')]: {
        margin: theme.spacing(10, 0, 10, 0),
    }, 
    [theme.breakpoints.down('md')]: {
        margin: theme.spacing(12,0, 6, 0),
    },     
  '& .DCSHeader':{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(10),
    gap: theme.spacing(2),
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginBottom: theme.spacing(6),
    },
  },
  '& .DCSBtn': {
    padding: theme.spacing(1.75, 2),
  },

}));
export default StyledBox;
